"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaMapper = exports.buildImageUrl = exports.mediaToGalleryItem = void 0;
var utils_1 = require("../utils");
var defenitions_1 = require("../defenitions");
var buildImage = function (mediaItem) {
    var title = utils_1.get(function () { return mediaItem.title; }, '');
    return {
        id: mediaItem.id,
        src: exports.buildImageUrl(mediaItem),
        description: '',
        title: title,
        link: undefined,
        type: 'Image',
    };
};
var buildVideo = function (mediaItem) {
    if (!mediaItem.video || !mediaItem.video.files || !mediaItem.video.files.length) {
        return null;
    }
    var firstVideo = mediaItem.video.files[0];
    var imageData = utils_1.get(function () { return mediaItem.thumbnail.url.split('/').reverse(); }, []);
    var videoData = utils_1.get(function () { return firstVideo.url.split('/').reverse(); }, []);
    var uri = utils_1.get(function () { return videoData[3]; }, '');
    var filename = utils_1.get(function () { return videoData[0]; }, 'file');
    var title = utils_1.get(function () { return mediaItem.title; }, '');
    var posterUri = utils_1.get(function () { return imageData[4]; }, '');
    var posterWidth = utils_1.get(function () { return firstVideo.width; }, 100);
    var posterHeight = utils_1.get(function () { return firstVideo.height; }, 100);
    return {
        id: mediaItem.id,
        src: "wix:video://v1/" + uri + "/" + filename + "#posterUri=" + posterUri + "&posterWidth=" + posterWidth + "&posterHeight=" + posterHeight,
        description: '',
        title: title,
        link: undefined,
        type: 'Video',
        thumbnail: exports.buildImageUrl(mediaItem),
    };
};
exports.mediaToGalleryItem = function (mediaItem) {
    if (!mediaItem) {
        return;
    }
    if (mediaItem.mediaType === defenitions_1.MediaItemType.video) {
        return buildVideo(mediaItem);
    }
    else {
        return buildImage(mediaItem);
    }
};
exports.buildImageUrl = function (mediaItem) {
    var missingMedia = {
        url: 'https://static.wixstatic.com/media/614034_103e8f4ab0ae4536a38b319d3eb437ed~mv2.png/v1/fill/w_500,h_500/missing-media.png',
        width: 500,
        height: 500,
    };
    var media = mediaItem
        ? mediaItem.mediaType === defenitions_1.MediaItemType.video
            ? mediaItem.thumbnail
            : mediaItem.image
        : missingMedia;
    var imageData = utils_1.get(function () { return media.url.split('/').reverse(); }, []);
    var uri = utils_1.get(function () { return imageData[4]; }, '');
    var fileName = utils_1.get(function () { return imageData[0]; }, 'file');
    return "wix:image://v1/" + uri + "/" + fileName + "#originWidth=" + media.width + "&originHeight=" + media.height;
};
exports.mediaMapper = function (media) { return ({
    mainMedia: (media || null) && exports.buildImageUrl(media.mainMedia),
    mediaItems: ((media && media.items) || []).map(exports.mediaToGalleryItem).filter(Boolean),
}); };
//# sourceMappingURL=mappers.js.map